<div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4"
  (click)="onClose()">
  <div class="bg-white dark:bg-slate-900 w-full max-w-xl rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 overflow-hidden"
    (click)="$event.stopPropagation()">
    <div class="px-6 py-4 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
      <h3 class="text-base font-extrabold text-slate-800 dark:text-slate-100">
        {{ isEdit ? 'แก้ไขกลุ่มประตู' : 'เพิ่มกลุ่มประตู' }}
      </h3>
      <button type="button" (click)="onClose()"
        class="w-9 h-9 rounded-xl text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer border-none bg-transparent">
        <span class="material-icons text-[20px]">close</span>
      </button>
    </div>

    <div class="p-6 space-y-4 max-h-[70vh] overflow-y-auto" *ngIf="!isLoading(); else loadingTpl">
      <div class="text-xs font-semibold text-slate-500">
        ลาน: <span class="text-slate-800 dark:text-slate-200">{{ siteName || formData.siteName || '-' }}</span>
      </div>

      <div class="space-y-1.5">
        <label class="text-xs font-bold text-slate-500">ชื่อกลุ่ม <span class="text-rose-500">*</span></label>
        <input type="text" [(ngModel)]="formData.name" placeholder="เช่น กลุ่มประตูหลัก"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
      </div>

      <div class="space-y-2">
        <div class="flex items-center justify-between">
          <label class="text-xs font-bold text-slate-500">เลือกประตู (แสดงชื่อ / บันทึกเป็น id)</label>
          <span class="text-[11px] text-slate-400 font-medium">เลือกแล้ว {{ formData.gateIds.length }} ประตู</span>
        </div>
        <div *ngIf="gateOptions.length === 0"
          class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50 text-xs text-slate-400">
          ไม่พบประตูในลานนี้
        </div>
        <div *ngIf="gateOptions.length > 0"
          class="max-h-56 overflow-y-auto rounded-xl border border-slate-200 dark:border-slate-700 divide-y divide-slate-100 dark:divide-slate-800">
          <label *ngFor="let gate of gateOptions"
            class="flex items-center gap-3 px-3 py-2.5 cursor-pointer hover:bg-amber-50/50 dark:hover:bg-slate-800/60">
            <input type="checkbox" class="rounded border-slate-300 text-amber-500 focus:ring-amber-400"
              [checked]="isGateSelected(gate.id)"
              (change)="toggleGate(gate.id, ($any($event.target).checked))" />
            <span class="text-sm font-semibold text-slate-700 dark:text-slate-200">{{ gate.name || ('#' + gate.id) }}</span>
            <span class="ml-auto text-[11px] font-mono text-slate-400">id {{ gate.id }}</span>
          </label>
        </div>
      </div>
    </div>

    <ng-template #loadingTpl>
      <div class="p-10 text-center text-slate-400 text-sm">กำลังโหลด...</div>
    </ng-template>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-between gap-3">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving() || isLoading()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50 shrink-0">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex gap-3 flex-1 justify-end">
        <button type="button" (click)="onClose()" [disabled]="isSaving()"
          class="flex-1 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 dark:text-slate-300 cursor-pointer bg-transparent disabled:opacity-50">
          ยกเลิก
        </button>
        <button type="button" (click)="onSave()" [disabled]="isSaving() || isLoading()"
          class="flex-1 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 text-sm font-black cursor-pointer border-none disabled:opacity-50">
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && itemId"
  [entityType]="activityEntityTypes.ParkingGateGroup"
  [entityId]="itemId"
  title="ประวัติกลุ่มประตู"
  [subtitle]="'#' + itemId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
